// import

import {styled, keyframes} from 'goober';
import type {ComponentProps} from 'react';

import type {PostNode} from 'libs/model';
import {Link} from 'modules/Link';
import {BannerImage} from 'modules/Solo';

// types

type Props = ComponentProps<typeof Styled> & {
  node: PostNode;
};

// vars

const lastParenRx = /\([^(]+$/;

// fns

const splitTitle = (title: string) => {
  if (title.length > 50) {
    title = title.replace(lastParenRx, '');
  }

  const bits = title.split(' ');
  const head = bits.slice(0, bits.length - 1).join(' ');
  const tail = bits.slice(-1);

  return (
    <>
      <span key="title" className="title">{head}</span>
      {' '}
      <span key="more" className="more">{tail}</span>
    </>
  );
};

// component

export function RelatedPost(props: Props) {
  const {node, ...rest} = props;

  return (
    <Styled {...rest}>
      <BannerImage height={500} node={node} width={500} />

      <header className="head">
        <Link href={node.meta.link} title={node.meta.title}>
          {splitTitle(node.meta.title)}
        </Link>
      </header>
    </Styled>
  );
}

// styles

const more = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(0.5rem);
  }
  100% {
    transform: translateX(0);
  }
`;

const Styled = styled('article')`
  &:hover .more::after { opacity: 1; }

  & .head {
    font-family: var(--font-head);
    font-weight: 400;
    letter-spacing: 0;
    white-space: nowrap;
    line-height: 1.75rem;
    margin: 0.5rem 0 0;
    overflow: hidden;
    height: 3.5rem;
  }

  & .title {
    white-space: normal;
  }

  & .more {
    &::after {
      content: "→";
      display: inline-block;
      margin-left: 0.25rem;
      color: var(--red);
      font-weight: 600;
      animation: ${more} 1.0s infinite ease-in-out;
      opacity: 0;
      transition: opacity 100ms linear;
      word-wrap: nowrap;
    }
  }
`;
